import type { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import { Logo } from '../Logo/Logo';
import { fullscreenStyle, logoStyle, messageStyle } from './LoadingScreen.css';

type Props = {
  children?: ReactNode;
};

export const LoadingScreen = ({ children }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <div className={fullscreenStyle}>
      <Logo aria-hidden="true" className={logoStyle} variant="symbol" />

      <div className={messageStyle}>{children ?? t('common:loading')}</div>
    </div>
  );
};
